import { render } from "./kanban_padrao.vue?vue&type=template&id=bd186c28"
import script from "./kanban_padrao.vue?vue&type=script&lang=js"
export * from "./kanban_padrao.vue?vue&type=script&lang=js"

import "./kanban_padrao.vue?vue&type=style&index=0&id=bd186c28&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__